// 워크스페이스 미초기화 상태에서 발생하는 예상된 에러 (Sentry 필터링 대상)
export class WorkspaceNotInitializedError extends Error {
  override readonly name = 'WorkspaceNotInitializedError' as const;

  constructor(message = 'Workspace not initialized') {
    super(message);
  }
}
